import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class MunicipalitiesService {

  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }
  getMunicipalities(
    pageIndex: number,
    sortDirection?: string,
    sortProperty?: string,
    uf?: string,
    descricao?: string,
  ) {

    const params = new HttpParams().set('page', pageIndex?.toString() || '0')
      .set('size', '10')
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
      .set('uf', 'MG')
      .set('description', descricao || '')
    return this.http.get(`${this.baseUrl}/v1/cities`, { params })
  }

}
